import React from 'react';
import { useSelector } from 'react-redux';
import styles from './index.module.scss';
import BlankTemplatePage from '../_blank_template_page';
import ListTemplatePage from '../_list_template_page';

const TabPage = () => {
  const blankOrList = useSelector((state) => state.currentTab.type);

  return (
    <div className={styles.tabPage}>
      {blankOrList === 'tab_blank' ? (
        <BlankTemplatePage />
      ) : blankOrList === 'tab_list' ? (
        <ListTemplatePage />
      ) : (
        <>
          <h2 className={styles.title}>Страница раздела</h2>
          <p className={styles.description}>Добро пожаловать на страницу раздела</p>
        </>
      )}
    </div>
  );
};

export default TabPage;
